import { ParsedUrlQuery, ParsedUrlQueryInput } from 'querystring';
import keysOf from 'utils/keysOf';

const getSortedQueryParams = (query: ParsedUrlQuery | ParsedUrlQueryInput): ParsedUrlQuery => {
  const sortedKeys = keysOf(query).sort((a, b) => `${a}`.localeCompare(`${b}`));
  return sortedKeys.reduce((acc, curr) => ({ ...acc, [curr]: query[curr] }), {});
};

export default getSortedQueryParams;
